import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-4 bg-white rounded-xl border-[1.5px] border-primary30 p-5",
  "data-testid": "handover-flow-strip"
}
const _hoisted_2 = {
  key: 0,
  "data-testid": "handover-expired-warning",
  class: "flex items-center gap-2 rounded p-2 bg-[#fef9e7] border border-[#f1c21b]"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-[#16161d] leading-[18px]" }, " Este convite expirou. Não é mais possível aprovar ou recusar candidatos. ", -1)
const _hoisted_4 = { class: "flex flex-col lg:flex-row lg:items-stretch gap-5" }
const _hoisted_5 = {
  class: "flex items-center gap-6 min-w-0",
  "data-testid": "flow-strip-transfer-group"
}
const _hoisted_6 = { class: "flex flex-col gap-2 min-w-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-sm font-semibold text-[#7f7f8e] text-left",
  "data-testid": "flow-strip-requester-label"
}, " Profissional que passou ", -1)
const _hoisted_8 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "shrink-0 w-6 h-6 text-primary30",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_9 = ["d"]
const _hoisted_10 = { class: "flex flex-col gap-2 min-w-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-sm font-semibold text-[#7f7f8e] text-left",
  "data-testid": "flow-strip-candidate-label"
}, " Profissional que pretende assumir ", -1)
const _hoisted_12 = {
  key: 1,
  class: "text-sm text-left text-[#7f7f8e]",
  "data-testid": "flow-strip-empty-candidate"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "hidden lg:block w-px self-stretch bg-[#e8e8ed] shrink-0 lg:ml-auto",
  "data-testid": "flow-strip-transfer-group-divider"
}, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col justify-center gap-2 lg:w-[260px] shrink-0"
}
const _hoisted_15 = {
  key: 0,
  class: "flex items-center gap-1.5 bg-[#f5f5f7] rounded-[6px] px-3.5 py-2.5 text-xs",
  "data-testid": "flow-strip-accepted-chip"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-[#52526f]" }, "Aceitou em", -1)
const _hoisted_17 = { class: "font-bold text-[#16161d]" }
const _hoisted_18 = {
  key: 1,
  class: "flex items-center gap-2 rounded p-2 bg-[#fef9e7] border border-[#f1c21b]",
  "data-testid": "flow-strip-queue-badge"
}
const _hoisted_19 = { class: "text-sm text-[#16161d] leading-[18px]" }
const _hoisted_20 = {
  key: 1,
  class: "hidden lg:block w-px self-stretch bg-[#e8e8ed] shrink-0"
}
const _hoisted_21 = {
  key: 2,
  class: "flex flex-col justify-center gap-2.5 lg:w-[260px] shrink-0"
}

import { computed } from 'vue'
import { format, parseISO } from 'date-fns'
import { mdiAlert, mdiArrowRight, mdiClockOutline } from '@mdi/js'
import type {
  DoctorSummary,
  InviteResponseV2
} from '@/Network/Types/Responses/HandoverInviteResponses'
import DoctorInfo from '@/components/DoctorInfo.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HandoverFlowStrip',
  props: {
    requester: {},
    candidate: {},
    message: {},
    totalInvites: {},
    isExpired: { type: Boolean, default: false },
    isProcessing: { type: Boolean, default: false }
  },
  emits: ["approve", "decline", "viewAllCandidates"],
  setup(__props: any) {

const props = __props;





const formattedAcceptedAt = computed(() => {
  if (!props.candidate?.acceptedAt) return ''
  try {
    return format(parseISO(props.candidate.acceptedAt), "dd/MM/yyyy 'às' HH:mm")
  } catch {
    return props.candidate.acceptedAt
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isExpired)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_icon, {
            size: "16",
            icon: _unref(mdiAlert),
            color: "#f1c21b",
            class: "shrink-0"
          }, null, 8, ["icon"]),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(DoctorInfo, {
            name: _ctx.requester.name,
            subtitle: `CRM ${_ctx.requester.crm}`,
            "avatar-url": _ctx.requester.avatarUrl,
            "nps-score": _ctx.requester.npsScore,
            size: "md"
          }, null, 8, ["name", "subtitle", "avatar-url", "nps-score"])
        ]),
        (_openBlock(), _createElementBlock("svg", _hoisted_8, [
          _createElementVNode("path", {
            d: _unref(mdiArrowRight),
            fill: "currentColor"
          }, null, 8, _hoisted_9)
        ])),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.candidate)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_11,
                _createVNode(DoctorInfo, {
                  name: _ctx.candidate.doctor?.name ?? '—',
                  subtitle: _ctx.candidate.doctor?.crm ? `CRM ${_ctx.candidate.doctor.crm}` : '',
                  "avatar-url": _ctx.candidate.doctor?.avatarUrl ?? null,
                  "nps-score": _ctx.candidate.doctor?.npsScore ?? null,
                  size: "md"
                }, null, 8, ["name", "subtitle", "avatar-url", "nps-score"])
              ], 64))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, " Nenhum candidato na fila "))
        ])
      ]),
      _hoisted_13,
      (formattedAcceptedAt.value || _ctx.message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (formattedAcceptedAt.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(formattedAcceptedAt.value), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    icon: _unref(mdiClockOutline),
                    color: "#f1c21b",
                    class: "shrink-0"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.message), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.candidate || _ctx.totalInvites > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20))
        : _createCommentVNode("", true),
      (_ctx.candidate || _ctx.totalInvites > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            (_ctx.candidate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(FilledButton, {
                    text: "Aprovar para este médico",
                    width: "100%",
                    height: "48px",
                    "data-testid": "approve-handover-button",
                    disabled: _ctx.isProcessing || _ctx.isExpired,
                    class: "bg-primary30",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('approve')))
                  }, null, 8, ["disabled"]),
                  _createVNode(OutlineButton, {
                    text: "Recusar troca",
                    width: "100%",
                    height: "48px",
                    "data-testid": "decline-handover-button",
                    disabled: _ctx.isProcessing || _ctx.isExpired,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('decline')))
                  }, null, 8, ["disabled"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.totalInvites > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "flex items-center justify-center gap-2 p-1 text-sm font-bold text-primary30",
                  "data-testid": "view-all-candidates-button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('viewAllCandidates')))
                }, [
                  _createVNode(_component_v_icon, {
                    size: "20",
                    icon: _unref(mdiArrowRight),
                    color: "#2F7F91"
                  }, null, 8, ["icon"]),
                  _createTextVNode(" Ver todos os candidatos ")
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})